import { render, staticRenderFns } from "./viewTeamTargets.vue?vue&type=template&id=1906af6f&"
import script from "./viewTeamTargets.vue?vue&type=script&lang=js&"
export * from "./viewTeamTargets.vue?vue&type=script&lang=js&"
import style0 from "./viewTeamTargets.vue?vue&type=style&index=0&id=1906af6f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports